import { lazy } from 'react'

export const DreamBodyV1 = lazy(() => import('./v1/DreamBodyV1'))
export const DreamBodyV2 = lazy(() => import('./v2/DreamBodyV2'))
